// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// This file was automatically generated using npm run codegen
// If you want to alter this file please do so via the above mentioned command
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
import * as Types from "../../../shared/types/schema";

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";
const defaultOptions = {} as const;
export type RouteEntryFragment = {
  __typename?: "RouteEntry";
  station: { __typename?: "Station"; id: string; name: string; code: string };
  time: { __typename?: "StationTime"; localDeparture?: string | null; localArrival?: string | null };
};

export type CapacityWithoutSegmentsFragment = {
  __typename?: "Capacity";
  decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
  increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
  isCapacityInitiated: boolean;
  seatsOnOfferExpected: number;
  minSeatsOnOffer: number;
};

export type CapacityFragment = {
  __typename?: "Capacity";
  decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
  increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
  isCapacityInitiated: boolean;
  seatsOnOfferExpected: number;
  minSeatsOnOffer: number;
  segmentCapacity: Array<{
    __typename?: "SegmentCapacityEntry";
    placeAvailable: number;
    placeBooked: number;
    placeReserved: number;
  }>;
};

export type RideFragment = {
  __typename?: "Ride";
  id: string;
  status: string;
  salesStopNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
  salesRestartNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
  rideCancellationAllowed: boolean;
  lastModified?: string | null;
  lastModifiedUsername: string;
  cancellationStatus: Types.CancellationStatus;
  cancellationDate?: string | null;
  saleStatus: Types.RideSaleStatus;
  numberOfPassengers: number;
  line: { __typename?: "Line"; id: string; code: string };
  capacity: {
    __typename?: "Capacity";
    decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
    increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
    isCapacityInitiated: boolean;
    seatsOnOfferExpected: number;
    minSeatsOnOffer: number;
  };
  route: Array<{
    __typename?: "RouteEntry";
    station: { __typename?: "Station"; id: string; name: string; code: string };
    time: { __typename?: "StationTime"; localDeparture?: string | null; localArrival?: string | null };
  }>;
};

export type FilterRidesQueryVariables = Types.Exact<{
  pageRequest: Types.PageRequest;
  rideFilter: Types.RideFilterInput;
  sort?: Types.InputMaybe<Types.SortInput>;
}>;

export type FilterRidesQuery = {
  __typename?: "Query";
  filterRides: {
    __typename?: "PagedRideResult";
    total: number;
    items: Array<{
      __typename?: "Ride";
      id: string;
      status: string;
      salesStopNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      salesRestartNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      rideCancellationAllowed: boolean;
      lastModified?: string | null;
      lastModifiedUsername: string;
      cancellationStatus: Types.CancellationStatus;
      cancellationDate?: string | null;
      saleStatus: Types.RideSaleStatus;
      numberOfPassengers: number;
      line: { __typename?: "Line"; id: string; code: string };
      capacity: {
        __typename?: "Capacity";
        decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
        increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
        isCapacityInitiated: boolean;
        seatsOnOfferExpected: number;
        minSeatsOnOffer: number;
      };
      route: Array<{
        __typename?: "RouteEntry";
        station: { __typename?: "Station"; id: string; name: string; code: string };
        time: { __typename?: "StationTime"; localDeparture?: string | null; localArrival?: string | null };
      }>;
    }>;
  };
};

export type FilterRidesForRideActionsQueryVariables = Types.Exact<{
  pageRequest: Types.PageRequest;
  rideFilter: Types.RideFilterInput;
  sort?: Types.InputMaybe<Types.SortInput>;
}>;

export type FilterRidesForRideActionsQuery = {
  __typename?: "Query";
  filterRides: {
    __typename?: "PagedRideResult";
    total: number;
    items: Array<{
      __typename?: "Ride";
      id: string;
      salesStopNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      salesRestartNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      capacity: {
        __typename?: "Capacity";
        decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
        increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
        isCapacityInitiated: boolean;
        seatsOnOfferExpected: number;
        minSeatsOnOffer: number;
      };
      route: Array<{
        __typename?: "RouteEntry";
        station: { __typename?: "Station"; id: string; name: string; code: string };
        time: { __typename?: "StationTime"; localDeparture?: string | null; localArrival?: string | null };
      }>;
    }>;
  };
};

export type FilterRidesForRideTableHeaderQueryVariables = Types.Exact<{
  pageRequest: Types.PageRequest;
  rideFilter: Types.RideFilterInput;
  sort?: Types.InputMaybe<Types.SortInput>;
}>;

export type FilterRidesForRideTableHeaderQuery = {
  __typename?: "Query";
  filterRides: { __typename?: "PagedRideResult"; items: Array<{ __typename?: "Ride"; id: string }> };
};

export type LoadCapacityQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type LoadCapacityQuery = {
  __typename?: "Query";
  getRide: {
    __typename?: "Ride";
    id: string;
    capacity: {
      __typename?: "Capacity";
      decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      isCapacityInitiated: boolean;
      seatsOnOfferExpected: number;
      minSeatsOnOffer: number;
      segmentCapacity: Array<{
        __typename?: "SegmentCapacityEntry";
        placeAvailable: number;
        placeBooked: number;
        placeReserved: number;
      }>;
    };
  };
};

export type UpdateSeatsOnOfferMutationVariables = Types.Exact<{
  rides: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
  expectedSeatsOnOffer: Types.Scalars["Int"]["input"];
}>;

export type UpdateSeatsOnOfferMutation = {
  __typename?: "Mutation";
  adjustSeatsOnOffer: Array<{
    __typename?: "Ride";
    id: string;
    lastModified?: string | null;
    capacity: {
      __typename?: "Capacity";
      decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      isCapacityInitiated: boolean;
      seatsOnOfferExpected: number;
      minSeatsOnOffer: number;
      segmentCapacity: Array<{
        __typename?: "SegmentCapacityEntry";
        placeAvailable: number;
        placeBooked: number;
        placeReserved: number;
      }>;
    };
  }>;
};

export type StopSalesMutationVariables = Types.Exact<{
  rides: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type StopSalesMutation = {
  __typename?: "Mutation";
  stopSales: Array<{
    __typename?: "Ride";
    id: string;
    salesStopNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
    salesRestartNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
    lastModified?: string | null;
    saleStatus: Types.RideSaleStatus;
    capacity: {
      __typename?: "Capacity";
      decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      isCapacityInitiated: boolean;
      seatsOnOfferExpected: number;
      minSeatsOnOffer: number;
      segmentCapacity: Array<{
        __typename?: "SegmentCapacityEntry";
        placeAvailable: number;
        placeBooked: number;
        placeReserved: number;
      }>;
    };
  }>;
};

export type RestartSalesMutationVariables = Types.Exact<{
  rides: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type RestartSalesMutation = {
  __typename?: "Mutation";
  restartSales: Array<{
    __typename?: "Ride";
    id: string;
    salesStopNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
    salesRestartNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
    lastModified?: string | null;
    saleStatus: Types.RideSaleStatus;
    capacity: {
      __typename?: "Capacity";
      decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      isCapacityInitiated: boolean;
      seatsOnOfferExpected: number;
      minSeatsOnOffer: number;
      segmentCapacity: Array<{
        __typename?: "SegmentCapacityEntry";
        placeAvailable: number;
        placeBooked: number;
        placeReserved: number;
      }>;
    };
  }>;
};

export type CancelRideMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type CancelRideMutation = {
  __typename?: "Mutation";
  cancelRide: {
    __typename?: "Ride";
    id: string;
    rideCancellationAllowed: boolean;
    lastModified?: string | null;
    saleStatus: Types.RideSaleStatus;
    capacity: {
      __typename?: "Capacity";
      decreaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      increaseNotPossibleReasons: Array<Types.CapacityManagementNotPossibleReasons>;
      isCapacityInitiated: boolean;
      seatsOnOfferExpected: number;
      minSeatsOnOffer: number;
      segmentCapacity: Array<{
        __typename?: "SegmentCapacityEntry";
        placeAvailable: number;
        placeBooked: number;
        placeReserved: number;
      }>;
    };
  };
};

export const CapacityWithoutSegmentsFragmentDoc = gql`
  fragment CapacityWithoutSegments on Capacity {
    decreaseNotPossibleReasons
    increaseNotPossibleReasons
    isCapacityInitiated
    seatsOnOfferExpected
    minSeatsOnOffer
  }
`;
export const CapacityFragmentDoc = gql`
  fragment Capacity on Capacity {
    ...CapacityWithoutSegments
    segmentCapacity {
      placeAvailable
      placeBooked
      placeReserved
    }
  }
  ${CapacityWithoutSegmentsFragmentDoc}
`;
export const RouteEntryFragmentDoc = gql`
  fragment RouteEntry on RouteEntry {
    station {
      id
      name
      code
    }
    time {
      localDeparture
      localArrival
    }
  }
`;
export const RideFragmentDoc = gql`
  fragment Ride on Ride {
    id
    status
    line {
      id
      code
    }
    salesStopNotPossibleReasons
    salesRestartNotPossibleReasons
    rideCancellationAllowed
    lastModified
    lastModifiedUsername
    capacity {
      ...CapacityWithoutSegments
    }
    route {
      ...RouteEntry
    }
    cancellationStatus
    cancellationDate
    saleStatus
    numberOfPassengers
  }
  ${CapacityWithoutSegmentsFragmentDoc}
  ${RouteEntryFragmentDoc}
`;
export const FilterRidesDocument = gql`
  query FilterRides($pageRequest: PageRequest!, $rideFilter: RideFilterInput!, $sort: SortInput) {
    filterRides(pageRequest: $pageRequest, rideFilter: $rideFilter, sort: $sort) {
      items {
        ...Ride
      }
      total
    }
  }
  ${RideFragmentDoc}
`;

/**
 * __useFilterRidesQuery__
 *
 * To run a query within a React component, call `useFilterRidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRidesQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      rideFilter: // value for 'rideFilter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFilterRidesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<FilterRidesQuery, FilterRidesQueryVariables> &
    ({ variables: FilterRidesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<FilterRidesQuery, FilterRidesQueryVariables>(FilterRidesDocument, options);
}
export function useFilterRidesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FilterRidesQuery, FilterRidesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<FilterRidesQuery, FilterRidesQueryVariables>(FilterRidesDocument, options);
}
export function useFilterRidesSuspenseQuery(
  baseOptions?:
    ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FilterRidesQuery, FilterRidesQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<FilterRidesQuery, FilterRidesQueryVariables>(FilterRidesDocument, options);
}
export type FilterRidesQueryHookResult = ReturnType<typeof useFilterRidesQuery>;
export type FilterRidesLazyQueryHookResult = ReturnType<typeof useFilterRidesLazyQuery>;
export type FilterRidesSuspenseQueryHookResult = ReturnType<typeof useFilterRidesSuspenseQuery>;
export const FilterRidesForRideActionsDocument = gql`
  query FilterRidesForRideActions($pageRequest: PageRequest!, $rideFilter: RideFilterInput!, $sort: SortInput) {
    filterRides(pageRequest: $pageRequest, rideFilter: $rideFilter, sort: $sort) {
      items {
        id
        capacity {
          ...CapacityWithoutSegments
        }
        route {
          ...RouteEntry
        }
        salesStopNotPossibleReasons
        salesRestartNotPossibleReasons
      }
      total
    }
  }
  ${CapacityWithoutSegmentsFragmentDoc}
  ${RouteEntryFragmentDoc}
`;

/**
 * __useFilterRidesForRideActionsQuery__
 *
 * To run a query within a React component, call `useFilterRidesForRideActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRidesForRideActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRidesForRideActionsQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      rideFilter: // value for 'rideFilter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFilterRidesForRideActionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FilterRidesForRideActionsQuery,
    FilterRidesForRideActionsQueryVariables
  > &
    ({ variables: FilterRidesForRideActionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<FilterRidesForRideActionsQuery, FilterRidesForRideActionsQueryVariables>(
    FilterRidesForRideActionsDocument,
    options
  );
}
export function useFilterRidesForRideActionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FilterRidesForRideActionsQuery,
    FilterRidesForRideActionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<FilterRidesForRideActionsQuery, FilterRidesForRideActionsQueryVariables>(
    FilterRidesForRideActionsDocument,
    options
  );
}
export function useFilterRidesForRideActionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<FilterRidesForRideActionsQuery, FilterRidesForRideActionsQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<FilterRidesForRideActionsQuery, FilterRidesForRideActionsQueryVariables>(
    FilterRidesForRideActionsDocument,
    options
  );
}
export type FilterRidesForRideActionsQueryHookResult = ReturnType<typeof useFilterRidesForRideActionsQuery>;
export type FilterRidesForRideActionsLazyQueryHookResult = ReturnType<typeof useFilterRidesForRideActionsLazyQuery>;
export type FilterRidesForRideActionsSuspenseQueryHookResult = ReturnType<
  typeof useFilterRidesForRideActionsSuspenseQuery
>;
export const FilterRidesForRideTableHeaderDocument = gql`
  query FilterRidesForRideTableHeader($pageRequest: PageRequest!, $rideFilter: RideFilterInput!, $sort: SortInput) {
    filterRides(pageRequest: $pageRequest, rideFilter: $rideFilter, sort: $sort) {
      items {
        id
      }
    }
  }
`;

/**
 * __useFilterRidesForRideTableHeaderQuery__
 *
 * To run a query within a React component, call `useFilterRidesForRideTableHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRidesForRideTableHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRidesForRideTableHeaderQuery({
 *   variables: {
 *      pageRequest: // value for 'pageRequest'
 *      rideFilter: // value for 'rideFilter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFilterRidesForRideTableHeaderQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FilterRidesForRideTableHeaderQuery,
    FilterRidesForRideTableHeaderQueryVariables
  > &
    ({ variables: FilterRidesForRideTableHeaderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<FilterRidesForRideTableHeaderQuery, FilterRidesForRideTableHeaderQueryVariables>(
    FilterRidesForRideTableHeaderDocument,
    options
  );
}
export function useFilterRidesForRideTableHeaderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FilterRidesForRideTableHeaderQuery,
    FilterRidesForRideTableHeaderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<FilterRidesForRideTableHeaderQuery, FilterRidesForRideTableHeaderQueryVariables>(
    FilterRidesForRideTableHeaderDocument,
    options
  );
}
export function useFilterRidesForRideTableHeaderSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        FilterRidesForRideTableHeaderQuery,
        FilterRidesForRideTableHeaderQueryVariables
      >
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    FilterRidesForRideTableHeaderQuery,
    FilterRidesForRideTableHeaderQueryVariables
  >(FilterRidesForRideTableHeaderDocument, options);
}
export type FilterRidesForRideTableHeaderQueryHookResult = ReturnType<typeof useFilterRidesForRideTableHeaderQuery>;
export type FilterRidesForRideTableHeaderLazyQueryHookResult = ReturnType<
  typeof useFilterRidesForRideTableHeaderLazyQuery
>;
export type FilterRidesForRideTableHeaderSuspenseQueryHookResult = ReturnType<
  typeof useFilterRidesForRideTableHeaderSuspenseQuery
>;
export const LoadCapacityDocument = gql`
  query LoadCapacity($id: ID!) {
    getRide(id: $id) {
      id
      capacity {
        ...Capacity
      }
    }
  }
  ${CapacityFragmentDoc}
`;

/**
 * __useLoadCapacityQuery__
 *
 * To run a query within a React component, call `useLoadCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCapacityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadCapacityQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<LoadCapacityQuery, LoadCapacityQueryVariables> &
    ({ variables: LoadCapacityQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<LoadCapacityQuery, LoadCapacityQueryVariables>(LoadCapacityDocument, options);
}
export function useLoadCapacityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadCapacityQuery, LoadCapacityQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<LoadCapacityQuery, LoadCapacityQueryVariables>(LoadCapacityDocument, options);
}
export function useLoadCapacitySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<LoadCapacityQuery, LoadCapacityQueryVariables>
) {
  const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<LoadCapacityQuery, LoadCapacityQueryVariables>(
    LoadCapacityDocument,
    options
  );
}
export type LoadCapacityQueryHookResult = ReturnType<typeof useLoadCapacityQuery>;
export type LoadCapacityLazyQueryHookResult = ReturnType<typeof useLoadCapacityLazyQuery>;
export type LoadCapacitySuspenseQueryHookResult = ReturnType<typeof useLoadCapacitySuspenseQuery>;
export const UpdateSeatsOnOfferDocument = gql`
  mutation UpdateSeatsOnOffer($rides: [ID!]!, $expectedSeatsOnOffer: Int!) {
    adjustSeatsOnOffer(rides: $rides, expectedSeatsOnOffer: $expectedSeatsOnOffer) {
      id
      lastModified
      capacity {
        ...Capacity
      }
    }
  }
  ${CapacityFragmentDoc}
`;

/**
 * __useUpdateSeatsOnOfferMutation__
 *
 * To run a mutation, you first call `useUpdateSeatsOnOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeatsOnOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeatsOnOfferMutation, { data, loading, error }] = useUpdateSeatsOnOfferMutation({
 *   variables: {
 *      rides: // value for 'rides'
 *      expectedSeatsOnOffer: // value for 'expectedSeatsOnOffer'
 *   },
 * });
 */
export function useUpdateSeatsOnOfferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSeatsOnOfferMutation, UpdateSeatsOnOfferMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<UpdateSeatsOnOfferMutation, UpdateSeatsOnOfferMutationVariables>(
    UpdateSeatsOnOfferDocument,
    options
  );
}
export type UpdateSeatsOnOfferMutationHookResult = ReturnType<typeof useUpdateSeatsOnOfferMutation>;
export const StopSalesDocument = gql`
  mutation StopSales($rides: [ID!]!) {
    stopSales(rides: $rides) {
      id
      salesStopNotPossibleReasons
      salesRestartNotPossibleReasons
      lastModified
      capacity {
        ...Capacity
      }
      saleStatus
    }
  }
  ${CapacityFragmentDoc}
`;

/**
 * __useStopSalesMutation__
 *
 * To run a mutation, you first call `useStopSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSalesMutation, { data, loading, error }] = useStopSalesMutation({
 *   variables: {
 *      rides: // value for 'rides'
 *   },
 * });
 */
export function useStopSalesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<StopSalesMutation, StopSalesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<StopSalesMutation, StopSalesMutationVariables>(StopSalesDocument, options);
}
export type StopSalesMutationHookResult = ReturnType<typeof useStopSalesMutation>;
export const RestartSalesDocument = gql`
  mutation RestartSales($rides: [ID!]!) {
    restartSales(rides: $rides) {
      id
      salesStopNotPossibleReasons
      salesRestartNotPossibleReasons
      lastModified
      capacity {
        ...Capacity
      }
      saleStatus
    }
  }
  ${CapacityFragmentDoc}
`;

/**
 * __useRestartSalesMutation__
 *
 * To run a mutation, you first call `useRestartSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartSalesMutation, { data, loading, error }] = useRestartSalesMutation({
 *   variables: {
 *      rides: // value for 'rides'
 *   },
 * });
 */
export function useRestartSalesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RestartSalesMutation, RestartSalesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<RestartSalesMutation, RestartSalesMutationVariables>(
    RestartSalesDocument,
    options
  );
}
export type RestartSalesMutationHookResult = ReturnType<typeof useRestartSalesMutation>;
export const CancelRideDocument = gql`
  mutation CancelRide($id: ID!) {
    cancelRide(id: $id) {
      id
      rideCancellationAllowed
      lastModified
      capacity {
        ...Capacity
      }
      saleStatus
    }
  }
  ${CapacityFragmentDoc}
`;

/**
 * __useCancelRideMutation__
 *
 * To run a mutation, you first call `useCancelRideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRideMutation, { data, loading, error }] = useCancelRideMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelRideMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CancelRideMutation, CancelRideMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<CancelRideMutation, CancelRideMutationVariables>(CancelRideDocument, options);
}
export type CancelRideMutationHookResult = ReturnType<typeof useCancelRideMutation>;
